/**
 * DragMove — 사용자PC(/u/orders) 상세팝업(detailLists / orderEdit)의 드래그 이동.
 *
 * 레거시와의 관계
 * ───────────────
 * 기존 public/js/u-order-list.js 의 addListeners / mouseUp / mouseDown / divMove
 * (+ 상태 move_obj / DragClickX / last_boxPosx / last_boxPosy) 를 캡슐화했다.
 * 드래그 종료 시 마지막 위치를 쿠키에 저장한다. 다음 접속에서 blade 가 그 쿠키를 읽어
 * 팝업의 초기 left/top 을 찍는다 (OrderListController::popupPositions — 경계쿠키).
 * 같은 값을 서버 세션에도 적던 ajax(box-position)는 이중장부라 걷어냈다 (2026-09).
 *
 * 외부 진입점 → $j.Pages.Desktop.Orders.initialize() 가 window 로 브리지:
 *   - window.addListeners(tar, tarTop) : show_Pop_BizForm 이 팝업 오픈 시 호출
 *   (mouseUp/mouseDown/divMove 는 addEventListener 콜백 참조라 외부 노출 불필요.
 *    arrow 클래스필드 = 인스턴스당 안정 참조 → removeEventListener 정상 동작.)
 *
 * ⚠ 결합 — 모듈은 strict 이므로 blade 전역/공통헬퍼는 window.* 로 접근:
 *   - blade 전역 : window.isDown, window.posDefX/posDefY, window.editor_posDefX/editor_posDefY, window.debugA
 *   - 공통 헬퍼   : window.setCookie
 *   (move_obj/DragClickX/last_boxPosx/last_boxPosy 는 레거시에서 클러스터 전용
 *    (last_boxPos* 는 미선언 암묵적 전역)이라 모듈 인스턴스 필드로 내부화)
 */
import Store from '../../../Common/Store';

/**
 * 경계쿠키 이름 — PHP 상수 G5_COOKIE_PC_POS_X/Y · PC_EDITOR_POS_X/Y (app/Common/constants.php) 와
 * 값이 같아야 한다. 여기가 굽고 OrderListController::popupPositions 가 읽는다.
 */
const CK = {
    posX:       'posDefX',
    posY:       'posDefY',
    editorPosX: 'editor_posDefX',
    editorPosY: 'editor_posDefY',
};

export default class DragMove {
    constructor() {
        this._moveObj = null;         // (구)move_obj : 이동 대상 요소 id ("detailLists" | "orderEdit")
        this._dragClickX = 0;         // (구)DragClickX : 클릭지점 X 오프셋
        this._lastBoxPosx = undefined; // (구)last_boxPosx : 마지막 위치 (구현: 암묵적 전역)
        this._lastBoxPosy = undefined; // (구)last_boxPosy
    }

    /** 드래그 리스너 부착 (구 addListeners) */
    attach = (tar, tarTop) => {
        this._moveObj = tarTop;
        document.getElementById(tar).addEventListener('mousedown', this._onMouseDown, false);
        window.addEventListener('mouseup', this._onMouseUp, false);
    }

    _onMouseUp = () => {
        window.removeEventListener('mousemove', this._onMouseMove, true);
        if (window.isDown == 1) {
            if (typeof this._lastBoxPosx == undefined || typeof this._lastBoxPosx == "undefined") {
                if (this._moveObj == "detailLists") {
                    var obj = document.getElementById("detailLists");
                    this._lastBoxPosx = parseInt(obj.style.left);
                    this._lastBoxPosy = parseInt(obj.style.top);
                } else {
                    return;
                }
            }
            if (!this._lastBoxPosx || !this._lastBoxPosy) return;
            if (window.debugA == true) console.log("move_obj : " + this._moveObj);
            if (this._moveObj == "detailLists") {
                window.posDefX = this._lastBoxPosx;
                window.posDefY = this._lastBoxPosy;
                Store.cookie.set(CK.posX, window.posDefX, { days: 365 });
                Store.cookie.set(CK.posY, window.posDefY, { days: 365 });
            } else if (this._moveObj == "orderEdit") {
                window.editor_posDefX = this._lastBoxPosx;
                window.editor_posDefY = this._lastBoxPosy;
                Store.cookie.set(CK.editorPosX, window.editor_posDefX, { days: 365 });
                Store.cookie.set(CK.editorPosY, window.editor_posDefY, { days: 365 });
            }
        }
    }

    _onMouseDown = (evt) => {
        if (evt.target.id == "detailExpanseClosediv" || evt.target.id == "detailExpanseCloseself") { window.isDown = 0; return; }
        window.isDown = 1;
        var rt = evt.target.getBoundingClientRect();
        this._dragClickX = evt.clientX - rt.x;
        window.addEventListener('mousemove', this._onMouseMove, true);
        return false;
    }

    _onMouseMove = (e) => {
        var div = document.getElementById(this._moveObj);
        var n1 = e.clientX;
        var n2 = e.clientY;
        var cc = parseInt(div.style.width);

        if (isNaN(cc)) return;
        if (this._moveObj == "detailLists") {
            //n1 = parseInt(n1 - cc + 80);
        } else {
            //n1 = parseInt(n1  - 30);
        }
        n1 = parseInt(n1 - this._dragClickX);

        div.style.position = 'fixed';
        div.style.top = parseInt(n2 - 20) + 'px';
        div.style.left = parseInt(n1) + 'px';
        this._lastBoxPosx = n1;
        this._lastBoxPosy = n2;
    }
}
